import { Responsive, Core } from 'connex-cds';
import { DotWorkflowDesktop } from './DotWorkflowDesktop';
import { DotWorkflowMobile } from './DotWorkflowMobile';
import { useParams } from 'react-router';
import { mobileTicket } from '../../../../../../../api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { useTicketContext } from '../../../TicketContext';
import { useCompanySetup } from '../../../MasterDataProvider';
import { DEFAULT_COC_SETUP_TYPE } from '../../../cocSetupDefaults';

export const useGetCocSetup = () => {
  const { entityRef } = useParams();
  const { ticket } = useTicketContext();
  const ticketRef = ticket?.crn;
  const queryClient = useQueryClient();

  const companySetup = useCompanySetup();
  const cocSetupType = companySetup?.data?.batchMaterialSummaryTable ?? DEFAULT_COC_SETUP_TYPE;
  const queryParams = { coc_setup: cocSetupType };

  const cocSetupQueryKey = React.useMemo(
    () => ['setup', entityRef, 'coc-setup', ticketRef, cocSetupType],
    [cocSetupType, entityRef, ticketRef]
  );

  const cachedCocSetup = React.useMemo(() => {
    if (!entityRef || !ticketRef) {
      return null;
    }

    return queryClient?.getQueryData?.(cocSetupQueryKey) ?? null;
  }, [cocSetupQueryKey, entityRef, queryClient, ticketRef]);

  const query = useQuery({
    queryKey: cocSetupQueryKey,
    queryFn: () => mobileTicket.getCocSetup({ entityRef, ticketRef, queryParams }),
    staleTime: Infinity,
    enabled: !!entityRef && !!ticketRef && !companySetup?.isLoading,
    placeholderData: cachedCocSetup ?? undefined,
  });

  return {
    ...query,
    data: query?.data ?? cachedCocSetup,
  };
};

export const DotWorkflow = () => {
  const cocSetup = useGetCocSetup();
  const { ticket, order } = useTicketContext();

  const cocData = React.useMemo(() => {
    if (!cocSetup?.isLoading) {
      return cocSetup?.data;
    }

    return null;
  }, [cocSetup?.isLoading, cocSetup?.data]);

  if (cocSetup?.isLoading) return <Core.Spinner spin={cocSetup?.isLoading} />;

  return (
    <Responsive>
      <DotWorkflowMobile data={cocData} ticket={ticket} order={order} />
      <DotWorkflowDesktop data={cocData} ticket={ticket} order={order} />
    </Responsive>
  );
};
